import { Component } from 'react';
import '../../../../../styles/components/about-us.scss';
import {
  Binoculars,
  Goal,
  Handshake,
  Repeat,
  ShoppingCart,
  Trash2,
  Users,
  Building2,
  Package,
} from 'lucide-react';
import i18n from '../../../../../i18n';
import getAboutCounts from '../../../../../models/about';
import { AuctionHammer } from '../../../../common/icons';

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTimeline: null,
      stats: [
        {
          id: 1,
          value: 0,
          target: 0,
          label: i18n.t('active_buyers'),
          icon: Users,
          key: 'active_buyers',
        },
        {
          id: 2,
          value: 0,
          target: 0,
          label: i18n.t('active_clients'),
          icon: Building2,
          key: 'active_clients',
        },
        { id: 3, value: 0, target: 0, label: i18n.t('lots_sold'), icon: Package, key: 'lots_sold' },
        { id: 4, value: 0, target: 0, label: i18n.t('aucitons'), icon: AuctionHammer, key: 'auctions' },
      ],
      hasAnimated: false,
      isLoading: true,
    };
    this.statsRef = null;
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    await this.getCounts();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  async getCounts() {
    try {
      let response = await getAboutCounts();
      if (response.success) {
        let { data } = response;

        this.setState((prevState) => ({
          stats: prevState.stats.map((stat) => ({
            ...stat,
            target: data[stat.key] || 0,
          })),
          isLoading: false,
        }));
      }
    } catch (error) {
      console.error('Error fetching counts:', error);
      this.setState({ isLoading: false });
    }
  }

  handleScroll = () => {
    if (this.statsRef && !this.state.hasAnimated && !this.state.isLoading) {
      const rect = this.statsRef.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (isVisible) {
        this.setState({ hasAnimated: true });
        this.animateStats();
      }
    }
  };

  animateStats = () => {
    const { stats } = this.state;
    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;

    stats.forEach((stat, index) => {
      if (stat.target === 0) return;

      let currentStep = 0;
      const increment = stat.target / steps;

      const timer = setInterval(() => {
        currentStep++;
        const newValue = Math.min(Math.floor(increment * currentStep), stat.target);

        this.setState((prevState) => ({
          stats: prevState.stats.map((s, i) => (i === index ? { ...s, value: newValue } : s)),
        }));

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, stepDuration);
    });
  };

  handleTimelineHover = (index) => {
    this.setState({ activeTimeline: index });
  };

  handleTimelineLeave = () => {
    this.setState({ activeTimeline: null });
  };

  render() {
    const { activeTimeline, stats } = this.state;

    const principles = [
      {
        id: 1,
        title: i18n.t('our_mission'),
        icon: Goal,
        description: i18n.t('our_mission_info'),
      },
      {
        id: 2,
        title: i18n.t('our_vision'),
        icon: Binoculars,
        description: i18n.t('our_vision_info'),
      },
      {
        id: 3,
        title: i18n.t('our_values'),
        icon: Handshake,
        description: i18n.t('our_values_info'),
      },
    ];

    const bestOffers = [
      {
        id: 1,
        title: i18n.t('online_auctions'),
        icon: ShoppingCart,
        description: i18n.t('online_auction_info'),
      },
      {
        id: 2,
        title: i18n.t('waste_management'),
        icon: Trash2,
        description: i18n.t('waste_management_info'),
      },
      {
        id: 3,
        title: i18n.t('recycling'),
        icon: Repeat,
        description: i18n.t('recycling_info'),
      },
    ];

    const journeyData = [
      {
        id: 1,
        year: '2019',
        title: i18n.t('the_idea'),
        description: i18n.t('the_idea_info'),
        position: 'right',
      },
    ];

    return (
      <div className="stats-unique-wrapper">
        {/* Stats Section with Unique Classes */}
        <section className="stats-premium-section" ref={(ref) => (this.statsRef = ref)}>
          <div className="stats-premium-background">
            <div className="stats-premium-gradient"></div>
            <div className="stats-premium-pattern"></div>
          </div>
          
          <div className="stats-premium-container">
            <div className="stats-premium-header">
              <h2 className="stats-premium-title">{i18n.t('our_story_in_numbers')}</h2>
            </div>

            <div className="stats-premium-grid">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                const isAuctionHammer = stat.key === 'auctions';
                
                return (
                  <div 
                    key={stat.id} 
                    className={`stats-premium-card ${isAuctionHammer ? 'hammer-card' : ''}`}
                    style={{ animationDelay: `${index * 0.15}s` }}
                  >
                    <div className="stats-premium-card-inner">
                      <div className="stats-premium-icon-wrapper">
                        <div className="stats-premium-icon-bg"></div>
                        <div className="stats-premium-icon">
                          {isAuctionHammer ? (
                            <div className="animated-hammer">
                              <AuctionHammer />
                            </div>
                          ) : (
                            <Icon size={40} strokeWidth={1.5} />
                          )}
                        </div>
                      </div>
                      <div className="stats-premium-content">
                        <div className="stats-premium-value">
                          {stat.value.toLocaleString()}+
                        </div>
                        <div className="stats-premium-label">{stat.label}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Statistics;